import keycloak, {
  getIdToken,
  getParsedIdToken,
  getParsedToken,
  getToken,
} from '../../framework/utils/KeycloakUtils';
// import { BuiltinRole } from '../constants';
import { UserInfo } from '../models/UserInfo';

// UserInfo
type KeycloakParsedTokenFieldToUse = {
  preferred_username: string;
  name: string;
  email: string;
  // Mapper
  organization_code: string;
  tel: string;
  staff_id: string;
  name_k: string;
  occupation: string;
  role_id: string;
  family_name_k: string;
  given_name_k: string;
  facility_pid: string; // Keycloakから渡されるfacility_pidは文字列である
  userCode: string;
  roleType: string;
  personal_info_agree_required: boolean;
  password_change_required: boolean;
};
let userInfo: UserInfo | undefined = undefined;
const getUserInfo = () => userInfo;
const setUserInfo = () => {
  // const t = keycloak.tokenParsed as Keycloak.KeycloakTokenParsed &
  //   KeycloakParsedTokenFieldToUse;
  // userInfo = {
  //   id: t.sub || '',
  //   account: t.preferred_username || '',
  //   name: t.name || '',
  //   email: t.email || '',
  //   organizationCode: t.organization_code || '',
  //   tel: t.tel || '',
  //   staffId: t.staff_id || '',
  //   nameK: t.name_k || '',
  //   occupation: t.occupation || '',
  //   roleIds: [t.role_id || 'user'],
  //   familyNameK: t.family_name_k || '',
  //   givenNameK: t.given_name_k || '',
  //   facilityPid: parseInt(t.facility_pid || '', 10),
  //   userCode: t.userCode || '',
  //   roleType: t.roleType || '',
  //   personal_info_agree_required: t.personal_info_agree_required || false,
  //   password_change_required: t.password_change_required || false,
  // };
  // debug
  userInfo = {
    id: '5',
    account: 'GH0001',
    name: '法人　太郎',
    email: '',
    organizationCode: '02',
    tel: '',
    staffId: '',
    nameK: '',
    occupation: '',
    roleIds: ['5'],
    familyNameK: '',
    givenNameK: '',
    facilityPid: 1,
    userCode: 'GH0001',
    roleType: '1',
    personal_info_agree_required: false,
    password_change_required: false,
  };
};
const overwriteUserInfo = (info: UserInfo | undefined) => {
  userInfo = info;
};

const clearUserInfo = () => {
  userInfo = undefined;
};

export const UserInfoAccessor = {
  getUserInfo,
  setUserInfo,
  clearUserInfo,
  getToken,
  getIdToken,
  getParsedToken,
  getParsedIdToken,
  overwriteUserInfo,
};
